module.exports = __webpack_public_path__ + "img/cart-list-bg-hen.d60bdc92.png";